import React from 'react';
import {defineBlock, useEditor, EditableImg, smartProps, EditableText, useInspectorControl, useSmartProp} from '@smartfire/gutenberg-react';
import {PanelBody, PanelRow, TextControl, ColorPalette} from "@wordpress/components"
import style from './block.module.scss';
import classnames from 'classnames';
import colorPalette from "../shared/colorPalette";


const Inspector = ()=>{

    const [link, setLink] = useSmartProp("link");
    const [color, setColor] = useSmartProp("color");

    return<PanelBody title="Propriétés">
        <PanelRow>
            <TextControl 
                label="lien du bouton"
                value={link}
                onChange = {(val)=>setLink(val)}
            />
        </PanelRow>
         <PanelRow > 
            <ColorPalette
                value={ color }
                onChange={ ( val ) => setColor( val ) }
                colors={colorPalette}
            />
        </PanelRow>
    </PanelBody>
}
function Block ({link, color}) {
    const {isEditing} = useEditor();
    useInspectorControl(Inspector)
    const blockClasses = classnames({
        [style.block]: true,
        [style.editor]: isEditing,
    })

    return <div className={blockClasses}>
        <div className={style.row}>
            <div className={style.icon}><EditableImg  smartProp="icon"/></div>
            <span style={{color: color}}><EditableText className={style.title} smartProp="title" tagName="h3"  /></span>
        </div>
        <span style={{color: color}}><EditableText allowedFormats={["core/bold"]} className={style.subtitle} smartProp="subtitle" /></span>
        <EditableText className={style.description} smartProp="description" />
        <a style={{backgroundColor: color}} className={style.button} href={!isEditing && link}><EditableText className={style.linkText} smartProp="linkText" /></a>
    </div>
}

export default defineBlock ({
    Block,
    smartProps: {
        icon: smartProps.any.withDefault(),    
        title: smartProps.string.withDefault(""),
        subtitle: smartProps.string.withDefault(""),
        description: smartProps.string.withDefault(""),
        link: smartProps.string.withDefault(""),
        linkText: smartProps.string.withDefault(""),
        color: smartProps.string.withDefault(style.red),
    },
    setup: {
        title: 'Offre',
        parent: ["smartfire/offres"],
    }
})
